module.exports = __webpack_public_path__ + "static/media/screenshot(10).b98d86b0.jpg";